/* Enlin night-light theme — interactions + real Shopify cart (AJAX Cart API).
   Loaded on every page (header/footer/cart drawer live on all templates);
   landing-only parts are guarded by element checks. No libraries. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = () => matchMedia('(min-width: 900px)').matches;
  const pad = (n) => String(n).padStart(2, '0');

  let CFG = {};
  try { CFG = JSON.parse(($('#enlin-config') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  const R = Object.assign({ root: '/', cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' }, CFG.routes || {});
  const join = (base, path) => base.replace(/\/$/, '') + path;

  /* money: shop money format, amounts in cents */
  const moneyFormat = CFG.money_format || '${{amount}}';
  function fmt(cents) {
    const v = (Number(cents) || 0) / 100;
    const two = v.toFixed(2);
    const withCommas = (s, t, d) => { const [a, b] = s.split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? d + b : ''); };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withCommas(String(Math.round(v)), ',', '.');
      if (k === 'amount_with_comma_separator') return withCommas(two, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withCommas(String(Math.round(v)), '.', ',');
      return withCommas(two, ',', '.');
    });
  }

  /* ── countdown to local midnight (announcement bar, offer timer, capsule) ── */
  const cds = $$('.js-countdown');
  const th = $('.js-t-h'), tm = $('.js-t-m'), ts = $('.js-t-s');
  function tick() {
    const now = new Date();
    const end = new Date(now);
    end.setHours(24, 0, 0, 0);
    let s = Math.max(0, Math.floor((end - now) / 1000));
    const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
    s %= 60;
    const str = `${pad(h)}:${pad(m)}:${pad(s)}`;
    cds.forEach((el) => { el.textContent = str; });
    if (th) { th.textContent = pad(h); tm.textContent = pad(m); ts.textContent = pad(s); }
  }
  if (cds.length || th) { tick(); setInterval(tick, 1000); }

  /* ── reveal on scroll ──────────────────────────────────── */
  const rio = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      rio.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  $$('.rv').forEach((el) => rio.observe(el));
  window.__enlin = true;   // reveal observer is live — the no-JS fallback can stand down
  document.addEventListener('shopify:section:load', (e) => $$('.rv', e.target).forEach((el) => el.classList.add('in')));

  /* ── decorative loops run only while their section is on screen ── */
  const lio = new IntersectionObserver((entries) => {
    entries.forEach((e) => e.target.classList.toggle('is-live', e.isIntersecting));
  }, { rootMargin: '80px 0px' });
  $$('.js-live').forEach((el) => lio.observe(el));

  /* ── before / after: the same room, lamp off → stars on ── */
  const ba = $('.js-ba');
  if (ba) {
    const btn = $('.js-ba-toggle', ba), state = $('.js-ba-state', ba);
    let touched = false;
    const setOn = (on) => {
      ba.dataset.on = String(on);
      btn.setAttribute('aria-checked', String(on));
      state.textContent = on ? 'on' : 'off';
    };
    btn.addEventListener('click', () => { touched = true; setOn(ba.dataset.on !== 'true'); });
    const bio = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      bio.disconnect();
      setTimeout(() => { if (!touched) setOn(true); }, reduce ? 0 : 900);
    }, { threshold: 0.55 });
    bio.observe($('.ba__frame', ba));
  }

  /* ── sky picker (radio group with arrow keys) ─────────── */
  const discs = $$('.disc');
  const domeImg = $('.js-dome-img'), domeName = $('.js-dome-name'), domeIdx = $('.js-dome-idx');
  const arrowTarget = (key, i, n) => {
    const t = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: n - 1 }[key];
    return t === undefined ? null : (t + n) % n;
  };
  if (discs.length && domeImg) {
    const pick = (i, focus) => {
      discs.forEach((d, j) => {
        d.setAttribute('aria-checked', String(j === i));
        d.tabIndex = j === i ? 0 : -1;
      });
      const d = discs[i];
      if (focus) d.focus();
      domeName.textContent = $('span', d).textContent;
      domeIdx.textContent = `${pad(i + 1)} / ${pad(discs.length)}`;
      const src = d.dataset.full;
      if (!src || domeImg.getAttribute('src') === src) return;
      domeImg.classList.add('is-swapping');
      setTimeout(() => {
        domeImg.src = src;
        domeImg.alt = d.dataset.alt;
        Promise.resolve(domeImg.decode ? domeImg.decode() : null)
          .catch(() => {})
          .then(() => domeImg.classList.remove('is-swapping'));
      }, reduce ? 0 : 230);
    };
    discs.forEach((d, i) => {
      d.addEventListener('click', () => pick(i));
      d.addEventListener('keydown', (e) => {
        const n = arrowTarget(e.key, i, discs.length);
        if (n === null) return;
        e.preventDefault();
        pick(n, true);
      });
    });
    const start = Math.max(0, discs.findIndex((d) => d.getAttribute('aria-checked') === 'true'));
    pick(start);
  }

  /* ── one button, three taps ────────────────────────────── */
  const panel = $('.js-panel');
  if (panel) {
    const shots = $$('.panel__screen img', panel);
    const steps = $$('.step', panel);
    const touch = $('.js-touch', panel);
    const count = $('.js-mode-count', panel);
    const status = $('.js-mode-status', panel);
    const NAMES = steps.map((s) => ($('.step__t', s) || s).textContent.trim());
    let mode = 0, timer = null, stopped = false, autoSteps = 0;
    const setMode = (m, byUser, focus) => {
      mode = m;
      panel.dataset.mode = String(m);
      shots.forEach((s, i) => {
        s.classList.toggle('is-on', i === m);
        if (i === m) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      steps.forEach((s, i) => {
        s.classList.toggle('is-on', i === m);
        s.setAttribute('aria-checked', String(i === m));
        s.tabIndex = i === m ? 0 : -1;
      });
      if (count) count.innerHTML = `<b>${m + 1}</b> ${m ? 'taps' : 'tap'}`;
      if (byUser && status) status.textContent = `${m + 1} ${m ? 'taps' : 'tap'}: ${NAMES[m] || ''}`;
      if (focus) steps[m].focus();
      if (!reduce && touch) { touch.classList.remove('pulse'); void touch.offsetWidth; touch.classList.add('pulse'); }
    };
    const stopAuto = () => { stopped = true; clearInterval(timer); timer = null; };
    if (touch) touch.addEventListener('click', () => { stopAuto(); setMode((mode + 1) % shots.length, true); });
    steps.forEach((s, i) => {
      s.addEventListener('click', () => { stopAuto(); setMode(i, false); });
      s.addEventListener('keydown', (e) => {
        const n = arrowTarget(e.key, i, steps.length);
        if (n === null) return;
        e.preventDefault();
        stopAuto();
        setMode(n, false, true);
      });
    });
    ['focusin', 'pointerenter', 'touchstart'].forEach((ev) => panel.addEventListener(ev, stopAuto, { passive: true }));
    if (!reduce) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !stopped && !timer) {
            timer = setInterval(() => {
              setMode((mode + 1) % shots.length, false);
              if (++autoSteps >= shots.length) stopAuto();
            }, 3200);
          } else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.4 }).observe(panel);
    }
  }

  /* ── big numerals count up once (only after the first scroll) ── */
  if (!reduce && $$('.js-count').length) {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        const el = e.target, to = +el.dataset.to, t0 = performance.now(), D = 1300;
        const step = (t) => {
          const p = Math.min(1, (t - t0) / D);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    addEventListener('scroll', () => {
      $$('.js-count').forEach((el) => {
        if (el.getBoundingClientRect().top <= innerHeight) return;
        el.textContent = '0';
        cio.observe(el);
      });
    }, { once: true, passive: true });
  }

  /* ── FAQ: smooth open / close ─────────────────────────── */
  $$('.faq details').forEach((d) => {
    const sum = $('summary', d), body = $('.faq__a', d);
    if (!sum || !body) return;
    let anim = null;
    sum.addEventListener('click', (e) => {
      if (reduce || !body.animate) return;
      e.preventDefault();
      if (anim) { anim.cancel(); anim = null; }
      if (!d.open || d.classList.contains('is-closing')) {
        d.classList.remove('is-closing');
        d.open = true;
        const h = body.scrollHeight;
        anim = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
          { duration: 380, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      } else {
        d.classList.add('is-closing');
        const h = body.offsetHeight;
        anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 280, easing: 'cubic-bezier(.4, 0, .6, 1)' });
        anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); anim = null; };
      }
    });
  });

  /* ── review scroller is focusable only while it scrolls ── */
  const cards = $('.cards');
  if (cards) {
    const syncCards = () => {
      const scrolls = cards.scrollWidth > cards.clientWidth + 2;
      if (scrolls) { cards.tabIndex = 0; cards.setAttribute('role', 'region'); cards.setAttribute('aria-label', 'More reviews'); }
      else { cards.removeAttribute('tabindex'); cards.removeAttribute('role'); cards.removeAttribute('aria-label'); }
    };
    syncCards();
    addEventListener('resize', syncCards, { passive: true });
  }

  /* ════════════════ CART (Shopify AJAX Cart API) ════════════════ */
  const drawer = $('#enlin-cart');
  const sheet = drawer && $('.drawer__panel', drawer);
  const badges = $$('.js-cart-count');
  const cartBtns = $$('.js-open-cart');
  const buybar = $('#buybar'), buyBtn = $('.js-buybar-btn'), hdr = $('#hdr');
  const hdrBuy = hdr && $('.hdr__buy', hdr);
  const bundlesForm = $('.js-bundles');
  let cart = CFG.cart || null;
  let lastFocus = null, closing = null, busy = false;

  const outsideEls = () => [$('.skip'), $('.ann'), hdr, $('#MainContent') || $('main'), $('.foot'), buybar].filter(Boolean);
  const productQty = () => (cart ? cart.items.filter((it) => String(it.product_id) === String(CFG.product_id)).reduce((a, it) => a + it.quantity, 0) : 0);

  async function api(url, body) {
    const res = await fetch(url, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
    } : { headers: { Accept: 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || 'Couldn’t update your cart. Please try again.');
    return data;
  }
  const getCart = () => api(join(R.cart, '.js'));
  const errText = (err) => (err instanceof TypeError ? 'Connection problem. Please check your internet and try again.' : err.message);

  function setBusy(on) {
    busy = on;
    if (drawer) drawer.setAttribute('aria-busy', String(on));
  }

  function showError(msg) {
    const el = drawer && $('.js-cart-error', drawer);
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function renderCart() {
    const count = cart ? cart.item_count : 0;
    badges.forEach((b) => { b.hidden = !count; b.textContent = count; });
    cartBtns.forEach((b) => b.setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'}`));
    if (!drawer) { renderBars(); return; }
    const has = count > 0;
    // remember which quantity button had focus: the lines are rebuilt below
    const fa = document.activeElement;
    const refocus = sheet && sheet.contains(fa) && fa.dataset && fa.dataset.line ? { line: fa.dataset.line, plus: fa.classList.contains('js-qty-plus') } : null;
    $('.js-cart-empty', drawer).hidden = has;
    $('.js-sum', drawer).hidden = !has;
    const lines = $('.js-lines', drawer);
    lines.innerHTML = '';
    if (has) {
      cart.items.forEach((it, idx) => {
        const row = document.createElement('div');
        row.className = 'line';
        const img = it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2')}${it.image.includes('?') ? '&' : '?'}width=200" width="72" height="92" loading="lazy" alt="">` : '<span class="line__ph"></span>';
        const variant = it.variant_title && !/default title/i.test(it.variant_title) ? `<span>${escapeHtml(it.variant_title)}</span>` : '';
        const was = it.original_line_price > it.final_line_price ? `<s>${fmt(it.original_line_price)}</s>` : '';
        row.innerHTML = `${img}
          <div class="line__info">
            <b>${escapeHtml(it.product_title)}</b>${variant}
            <div class="qty">
              <button type="button" data-line="${idx + 1}" data-q="${it.quantity - 1}" aria-label="One fewer">−</button>
              <output aria-live="polite">${it.quantity}</output>
              <button type="button" data-line="${idx + 1}" data-q="${it.quantity + 1}" aria-label="One more" class="js-qty-plus">+</button>
            </div>
          </div>
          <p class="line__price">${fmt(it.final_line_price)}${was ? '<br>' + was : ''}</p>`;
        lines.appendChild(row);
      });
      // discounts: line-level allocations grouped by title + cart-level applications
      const disc = {};
      cart.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => {
        const t = (a.discount_application && a.discount_application.title) || 'Discount';
        disc[t] = (disc[t] || 0) + a.amount;
      }));
      (cart.cart_level_discount_applications || []).forEach((a) => { disc[a.title || 'Discount'] = (disc[a.title] || 0) + a.total_allocated_amount; });
      const discRows = $('.js-disc-rows', drawer);
      discRows.innerHTML = Object.entries(disc).map(([t, v]) => `<div class="sum__disc"><dt>${escapeHtml(t)}</dt><dd>−${fmt(v)}</dd></div>`).join('');
      $('.js-sub', drawer).textContent = fmt(cart.original_total_price);
      $('.js-total', drawer).textContent = fmt(cart.total_price);
    }
    const co = $('.js-checkout', drawer);
    co.disabled = !has;
    co.textContent = has ? `Check out — ${fmt(cart.total_price)}` : 'Check out';
    // bundle nudge
    const q = productQty();
    const tiers = (CFG.bundles || []).slice().sort((a, b) => a.q - b.q);
    const next = tiers.find((t) => t.q > q && t.pct > 0);
    const nudge = $('.js-nudge', drawer);
    const show = has && q > 0 && next && next.q === q + 1 && CFG.available !== false;
    nudge.hidden = !show;
    if (show) {
      $('.js-nudge-text', drawer).innerHTML = `Add ${q === 1 ? 'a second' : 'another'} lamp and save <b>${next.pct}%</b> on ${next.q === 2 ? 'both' : 'all ' + next.q}`;
    }
    const a = document.activeElement;
    if (!drawer.hidden && (refocus || (a && sheet.contains(a) && a.closest('[hidden]')))) {
      const same = refocus && $(`[data-line="${refocus.line}"]${refocus.plus ? '.js-qty-plus' : ':not(.js-qty-plus)'}`, drawer);
      (same || $('.js-qty-plus', drawer) || $('.drawer__x', drawer)).focus();
    }
    renderBars();
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function openCart() {
    if (!drawer) { location.href = R.cart; return; }
    if (closing) { clearTimeout(closing); closing = null; drawer.classList.remove('is-closing'); return; }
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('enlin-cart-open');   // hides the Shopify Inbox chat bubble over the checkout button
    outsideEls().forEach((el) => { el.inert = true; });
    updateBars();
    requestAnimationFrame(() => sheet.focus());
    getCart().then((c) => { cart = c; showError(''); renderCart(); }).catch(() => {});
  }
  function closeCart() {
    if (!drawer || drawer.hidden || closing) return;
    const done = () => {
      clearTimeout(closing); closing = null;
      drawer.classList.remove('is-closing');
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('enlin-cart-open');
      outsideEls().forEach((el) => { el.inert = false; });
      updateBars();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    if (reduce) { done(); return; }
    drawer.classList.add('is-closing');
    closing = setTimeout(done, 330);
  }

  async function addToCart(qty, triggerEl) {
    if (busy || !CFG.variant_id || CFG.available === false) return;
    setBusy(true); showError('');
    if (triggerEl) triggerEl.setAttribute('aria-busy', 'true');
    try {
      await api(join(R.cart_add, '.js'), { items: [{ id: CFG.variant_id, quantity: qty }] });
      cart = await getCart();
      renderCart();
      cartBtns.forEach((b) => { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
      openCart();
    } catch (err) {
      openCart();
      showError(errText(err));
    } finally {
      setBusy(false);
      if (triggerEl) triggerEl.removeAttribute('aria-busy');
    }
  }

  async function changeLine(line, quantity) {
    if (busy) return;
    setBusy(true); showError('');
    try {
      cart = await api(join(R.cart_change, '.js'), { line, quantity: Math.max(0, quantity) });
      renderCart();
      const st = drawer && $('.js-cart-status', drawer);
      if (st) st.textContent = quantity > 0 ? `Quantity ${quantity}` : 'Removed from cart';
    } catch (err) { showError(errText(err)); } finally { setBusy(false); }
  }

  // product forms (hero, final): JS path adds via AJAX; without JS the form posts normally
  $$('form.js-product-form').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const q = +((f.querySelector('input[name="quantity"]:checked') || f.querySelector('input[name="quantity"]') || {}).value) || 1;
    addToCart(q, f.querySelector('[type="submit"]'));
  }));
  $$('.js-add').forEach((b) => b.addEventListener('click', () => addToCart(+b.dataset.qty || 1, b)));
  cartBtns.forEach((b) => b.addEventListener('click', (e) => { if (document.querySelector('cart-items')) return; e.preventDefault(); openCart(); }));
  if (drawer) {
    $$('.js-close-cart', drawer).forEach((b) => b.addEventListener('click', closeCart));
    drawer.addEventListener('click', (e) => {
      const q = e.target.closest('[data-line]');
      if (q) changeLine(+q.dataset.line, +q.dataset.q);
      if (e.target.closest('.js-nudge-add')) addToCart(1);
    });
    $('.js-checkout', drawer).addEventListener('click', () => { location.href = R.root.replace(/\/?$/, '/') + 'checkout'; });
    document.addEventListener('keydown', (e) => {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { closeCart(); return; }
      if (e.key !== 'Tab') return;
      const f = $$('button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])', sheet).filter((el) => !el.closest('[hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === sheet)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* bundles → one CTA that always says what it adds */
  const bundleLabel = $('.js-bundle-label');
  const chosen = () => (bundlesForm ? +($('input:checked', bundlesForm) || {}).value || 1 : 1);
  const bundle = (q) => (CFG.bundles || []).find((b) => b.q === q) || { q, total: (CFG.price || 0) * q, compare: (CFG.compare_at || 0) * q };
  const lamps = (q) => `${q} lamp${q > 1 ? 's' : ''}`;
  if (bundlesForm && bundleLabel) {
    const syncBundle = () => { if (CFG.available === false) return; const q = chosen(); bundleLabel.textContent = `Add ${lamps(q)} — ${fmt(bundle(q).total)}`; };
    bundlesForm.addEventListener('change', () => { syncBundle(); renderBars(); });
    syncBundle();
  }

  /* ── the buy button is always at hand ────────────────────── */
  const bbNow = $('.js-bb-now'), bbWas = $('.js-bb-was');
  const heroCta = $('#hero-cta');
  const watched = [heroCta, $('#offer-cta'), $('#final-cta')].filter(Boolean);
  const onScreen = new Set();
  let formInView = false;
  function renderBars() {
    if (!buybar && !hdrBuy) return;
    if (CFG.available === false) return;   // Liquid already rendered "Sold out"
    const q = chosen();
    const single = bundle(1);
    if (formInView) {
      if (bbNow) bbNow.textContent = fmt(bundle(q).total);
      if (bbWas) bbWas.textContent = fmt((CFG.compare_at || 0) * q);
      if (buyBtn) buyBtn.textContent = `Add ${lamps(q)}`;
      if (hdrBuy) hdrBuy.textContent = `Add ${lamps(q)} · ${fmt(bundle(q).total)}`;
    } else {
      if (bbNow) bbNow.textContent = fmt(single.total);
      if (bbWas) bbWas.textContent = fmt(CFG.compare_at || 0);
      const count = cart ? cart.item_count : 0;
      if (buyBtn) buyBtn.textContent = count > 0 ? `View cart · ${count}` : 'Add to cart';
      if (hdrBuy) hdrBuy.textContent = `Add to cart · ${fmt(single.total)}`;
    }
  }
  function updateBars() {
    if (!hdr) return;
    const none = watched.length > 0 && onScreen.size === 0;
    const closed = !drawer || drawer.hidden;
    if (buybar) {
      const show = none && closed && !desktop();
      buybar.classList.toggle('is-up', show);
      buybar.setAttribute('aria-hidden', String(!show));
      document.documentElement.classList.toggle('enlin-buybar-up', show);
      if (buyBtn) buyBtn.tabIndex = show ? 0 : -1;
    }
    if (hdrBuy) {
      hdr.classList.toggle('show-buy', none && desktop());
      hdrBuy.tabIndex = none && desktop() ? 0 : -1;
    }
    renderBars();
  }
  if (buyBtn) buyBtn.addEventListener('click', () => {
    if (formInView) addToCart(chosen(), buyBtn);
    else if (cart && cart.item_count > 0) openCart();
    else addToCart(1, buyBtn);
  });
  if (hdrBuy) hdrBuy.addEventListener('click', (e) => {
    e.stopImmediatePropagation();
    addToCart(formInView ? chosen() : 1, hdrBuy);
  }, true);

  if (watched.length) {
    let vio = null, fio = null;
    const watch = () => {
      if (vio) vio.disconnect();
      if (fio) fio.disconnect();
      onScreen.clear();
      const top = desktop() && hdr ? hdr.offsetHeight : 0;
      vio = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.intersectionRatio >= 0.95 ? onScreen.add(e.target) : onScreen.delete(e.target)));
        updateBars();
      }, { rootMargin: `-${top}px 0px 0px 0px`, threshold: [0, 0.95, 1] });
      watched.forEach((el) => vio.observe(el));
      if (bundlesForm) {
        fio = new IntersectionObserver((entries) => {
          formInView = entries.some((e) => e.isIntersecting);
          updateBars();
        }, { rootMargin: `-${top}px 0px 0px 0px` });
        fio.observe(bundlesForm);
      }
    };
    watch();
    matchMedia('(min-width: 900px)').addEventListener('change', watch);
  }

  if (hdr) {
    const onScroll = () => hdr.classList.toggle('is-stuck', scrollY > 30);
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  renderCart();
  // keep the badge honest if the cart changed in another tab or on the checkout
  addEventListener('pageshow', (e) => { if (e.persisted) getCart().then((c) => { cart = c; renderCart(); }).catch(() => {}); });
  // base-theme /cart page: Dawn's cart publishes cartUpdate after each change — keep the header badge in step
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => getCart().then((c) => { cart = c; renderCart(); }).catch(() => {}));
  }
})();
